import { GroupSecurity } from '@quromedical/fhir-common';
import { withPermissions } from 'components/groups';
import { PractitionerScreen } from 'screens/practitioner';

export default withPermissions(PractitionerScreen, [
  GroupSecurity.PractitionerRead,
]);
